import { BrazeMarketingChannelType } from 'constants/braze';
import { logSdkLoggingFailure } from './error-loggers';

async function brazeLogCardDismissal(card) {
  const {
    logCardDismissal
  } = await import('@braze/web-sdk');
  const isLogged = logCardDismissal(card);

  if (!isLogged) {
    var _card$extras, _card$extras2;

    logSdkLoggingFailure(card.id, 'card-dismissal', (_card$extras = card.extras) === null || _card$extras === void 0 ? void 0 : _card$extras.channel, (_card$extras2 = card.extras) === null || _card$extras2 === void 0 ? void 0 : _card$extras2.tracking);
  }

  return isLogged;
}

async function brazeLogCardClick(card) {
  const {
    logCardClick
  } = await import('@braze/web-sdk');
  const isLogged = logCardClick(card, true);

  if (!isLogged) {
    var _card$extras3, _card$extras4;

    logSdkLoggingFailure(card.id, 'card-click', (_card$extras3 = card.extras) === null || _card$extras3 === void 0 ? void 0 : _card$extras3.channel, (_card$extras4 = card.extras) === null || _card$extras4 === void 0 ? void 0 : _card$extras4.tracking);
  }

  return isLogged;
}

async function brazeLogCardImpressions() {
  const {
    logCardImpressions
  } = await import('@braze/web-sdk');

  for (var _len = arguments.length, cards = new Array(_len), _key = 0; _key < _len; _key++) {
    cards[_key] = arguments[_key];
  }

  const isLogged = logCardImpressions(cards, true);

  if (!isLogged) {
    cards.forEach(_ref => {
      let {
        id,
        extras
      } = _ref;
      logSdkLoggingFailure(id, 'card-impression', extras === null || extras === void 0 ? void 0 : extras.channel, extras === null || extras === void 0 ? void 0 : extras.tracking);
    });
  }

  return isLogged;
}

export async function brazeLogInAppMessageClick(_ref2) {
  let {
    original
  } = _ref2;
  const {
    logInAppMessageClick
  } = await import('@braze/web-sdk');
  const isLogged = logInAppMessageClick(original);

  if (!isLogged) {
    logSdkLoggingFailure(original.message, 'in-app-click', BrazeMarketingChannelType.InAppMessage, original.extras.tracking);
  }
}
export async function brazeLogInAppMessageButtonClick(_ref3, index) {
  let {
    original
  } = _ref3;
  const {
    logInAppMessageButtonClick
  } = await import('@braze/web-sdk');
  const isLogged = logInAppMessageButtonClick(original.buttons[index], original);

  if (!isLogged) {
    logSdkLoggingFailure(original.message, 'in-app-button-click', BrazeMarketingChannelType.InAppMessage, original.extras.tracking);
  }
}
export async function brazeLogInAppMessageImpression(_ref4) {
  let {
    original
  } = _ref4;
  const {
    logInAppMessageImpression
  } = await import('@braze/web-sdk');
  const isLogged = logInAppMessageImpression(original);

  if (!isLogged) {
    logSdkLoggingFailure(original.message, 'in-app-impression', BrazeMarketingChannelType.InAppMessage, original.extras.tracking);
  }
}
export const getCardLoggersById = cardStores => {
  const applyLogCardFunctionById = logCard => async id => {
    const foundCard = cardStores.flatMap(store => store.state).find(card => (card === null || card === void 0 ? void 0 : card.id) === id);
    if (!foundCard) return false;
    return logCard(foundCard);
  };

  return {
    logCardImpression: applyLogCardFunctionById(brazeLogCardImpressions),
    logCardClick: applyLogCardFunctionById(brazeLogCardClick),
    logCardDismissal: applyLogCardFunctionById(brazeLogCardDismissal)
  };
};